/**
 * Merch Page JavaScript
 * Handles category filtering, size selection, and scroll animations
 */

(function() {
  'use strict';

  /**
   * Category Filter Handler
   */
  class MerchFilters {
    constructor() {
      this.filterButtons = document.querySelectorAll('.merch-filter-btn');
      this.productCards = document.querySelectorAll('.merch-card[data-category]');

      if (this.filterButtons.length > 0) {
        this.init();
      }
    }

    init() {
      this.filterButtons.forEach(button => {
        button.addEventListener('click', (e) => this.handleFilter(e));
      });
    }

    handleFilter(e) {
      const button = e.currentTarget;
      const filter = button.dataset.filter;

      // Update active state
      this.filterButtons.forEach(btn => {
        btn.classList.remove('active');
        btn.setAttribute('aria-pressed', 'false');
      });
      button.classList.add('active');
      button.setAttribute('aria-pressed', 'true');

      // Filter products
      this.productCards.forEach((card, index) => {
        const category = card.dataset.category;
        const shouldShow = filter === 'all' || category === filter;

        if (shouldShow) {
          card.classList.remove('hidden');
          // Re-trigger animation
          card.style.animation = 'none';
          card.offsetHeight; // Force reflow
          card.style.animation = null;
          card.style.animationDelay = `${index * 0.05}s`;
        } else {
          card.classList.add('hidden');
        }
      });

      // Dispatch event so snowfall effect can recalculate page height
      window.dispatchEvent(new CustomEvent('merch:filterchange'));

      // Announce to screen readers
      this.announceFilterChange(filter);
    }

    announceFilterChange(filter) {
      const visibleCount = document.querySelectorAll('.merch-card:not(.hidden)').length;
      const announcement = document.createElement('div');
      announcement.setAttribute('role', 'status');
      announcement.setAttribute('aria-live', 'polite');
      announcement.className = 'merch-sr-only';
      announcement.textContent = `Showing ${visibleCount} ${filter === 'all' ? '' : filter + ' '}products`;

      document.body.appendChild(announcement);
      setTimeout(() => announcement.remove(), 1000);
    }
  }

  /**
   * Size Selector Handler
   */
  class MerchSizeSelector {
    constructor() {
      this.init();
    }

    init() {
      document.querySelectorAll('.merch-sizes').forEach(sizeContainer => {
        sizeContainer.addEventListener('click', (e) => {
          if (e.target.classList.contains('merch-size-btn') && !e.target.disabled) {
            this.handleSizeSelect(e.target, sizeContainer);
          }
        });
      });
    }

    handleSizeSelect(button, container) {
      // Update visual state
      container.querySelectorAll('.merch-size-btn').forEach(btn => {
        btn.classList.remove('selected');
        btn.setAttribute('aria-selected', 'false');
      });
      button.classList.add('selected');
      button.setAttribute('aria-selected', 'true');

      // Update hidden variant ID input
      const variantId = button.dataset.variantId;
      const form = container.closest('.merch-card').querySelector('.merch-form');
      if (form) {
        const input = form.querySelector('.merch-variant-id');
        if (input) {
          input.value = variantId;
        }

        // Update add button state based on variant availability
        const addButton = form.querySelector('.merch-add-btn');
        if (addButton) {
          const isAvailable = button.dataset.available === 'true';
          addButton.disabled = !isAvailable;
        }
      }
    }
  }

  /**
   * Smooth Scroll Handler for CTA buttons
   */
  class MerchScrollTo {
    constructor() {
      this.init();
    }

    init() {
      document.querySelectorAll('[data-scroll-to]').forEach(element => {
        element.addEventListener('click', (e) => {
          e.preventDefault();
          const targetId = element.dataset.scrollTo;
          const target = document.getElementById(targetId);

          if (target) {
            target.scrollIntoView({
              behavior: 'smooth',
              block: 'start'
            });

            // Set focus for accessibility
            target.setAttribute('tabindex', '-1');
            target.focus({ preventScroll: true });
          }
        });
      });
    }
  }

  /**
   * Add to Cart Loading State
   */
  class MerchAddToCart {
    constructor() {
      this.init();
    }

    init() {
      document.querySelectorAll('.merch-form').forEach(form => {
        form.addEventListener('submit', (e) => this.handleSubmit(e));
      });
    }

    handleSubmit(e) {
      const form = e.currentTarget;
      const button = form.querySelector('.merch-add-btn');

      if (button) {
        button.classList.add('loading');

        // Remove loading state after a delay (cart will handle the rest)
        setTimeout(() => {
          button.classList.remove('loading');
        }, 2000);
      }
    }
  }

  /**
   * Initialize on DOM ready
   */
  function init() {
    new MerchFilters();
    new MerchSizeSelector();
    new MerchScrollTo();
    new MerchAddToCart();
  }

  // Run when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-initialize on Shopify section render (for theme editor)
  document.addEventListener('shopify:section:load', function(event) {
    if (event.target.classList.contains('merch-page')) {
      init();
    }
  });
})();
